import React, { Fragment, useMemo } from 'react';
import { useEffect, useState } from 'react';
import { useAuthConfig } from "../../shared/utils";
import { DatePicker } from "@deere/ux.uxframe-react";
import Moment from 'moment';
import config from '../../shared/config';
import { Container, Row, Col, Breadcrumb, Form, Card, Alert } from '@deere/ux.uxframe-react';
import { TableContainerRequestView } from './RequestViewTable';
import { ERROR_MESSAGE } from '../../shared/Constants';
import { Loading } from '../../shared/Loading';
import { useUserInfo } from "../../shared/UserInfo";
export default function Queue() {

    const info = useUserInfo();
    var startdate = Moment();
    startdate = startdate.subtract(7, "days");
    var startdate1 = startdate.format("DD-MMM-YYYY");
    const [isLoading, setIsLoading] = useState(true);
    let authAxios = useAuthConfig();
    const headers = {
        "content-type": "application/json",
        "accept": "*/*"
    }
    const [flagForCount, getflagForCount] = useState(false)
    const [req, getqueue] = useState([{
        material: "",
        plant: "",
        fromDate: "",
        toDate: "",
        status: "",
        processorId: "",
        requestorId: "",
        managerId: "",
        flagFromPage: "requestlist"
    }]
    );

    const [queue, getque] = useState([]);
    const handlerequestorChange = (event) => {
        req.requestorId = event.target.value;
        handleSubmit(event);
    }

    const handlematerialChange = (event) => {
        req.material = event.target.value;
        handleSubmit(event);
    }
    const handleplantChange = (event) => {
        req.plant = event.target.value;
        handleSubmit();
    }

    const handlestatusChange = (event) => {
        req.status = event.target.value;
        handleSubmit(event);
    }

    const handleprocessorChange = (event) => {
        req.processorId = event.target.value;

        handleSubmit(event);
    }

    const handlefromDateChange = (event) => {


        req.fromDate = Moment(event.target.value).format('YYYY-MM-DD');
        handleSubmit(event);

    }

    const handletoDateChange = (event) => {

        req.toDate = Moment(event.target.value).format('YYYY-MM-DD');
        handleSubmit(event);
    }
    const [alertVariant, setAlertVariant] = useState('');
    const [alertVisible, setAlertVisible] = useState(false);
    const [message, getMessage] = useState('');

    const makeMessageHidden = (num) => {
        const timeout = setTimeout(() => {
            setAlertVisible(false)
        }, num)
        return () => clearTimeout(timeout)
    }

    const hideAlert = () => {
        setAlertVisible(false)
    }

    useEffect(() => {
        if (info&&info.userId) {
            getRequestList();
       }
    }, [info])
    const getRequestList = async () => {
        req.fromDate = Moment(startdate).format('YYYY-MM-DD');
        setIsLoading(true);
        await authAxios.post('/PDCReturn/requestList', {
            requestorId: req.requestorId,
            material: req.material,
            plant: req.plant,
            fromDate: req.fromDate,
            toDate: req.toDate,
            status: req.status,
            processorId: req.processorId,
            smUser: info&&info.userId,
            managerId: "",
            flagFromPage: "requestlist"

        }).then(
            res => {
                getque(res.data);
                setIsLoading(false);

            }

        ).catch(err => {
            setAlertVariant('warning');
            getMessage(ERROR_MESSAGE);
            setAlertVisible(true)
            makeMessageHidden(5000)
            setIsLoading(false);
        })
    }

    const sortarray = (arr) => {
        const sorted = arr.sort((a, b) => {
            return a.localeCompare(b, undefined, {
                numeric: true,
                sensitivity: 'base'
            })
        })
    }
    const sortarray2 = (arr) => {
        const sorted = arr.sort((a, b) => {
            return a.requestorName.localeCompare(b.requestorName)
        })
    }
    const sortarray3 = (arr) => {
        const sorted = arr.sort((a, b) => {
            return a.processorName.localeCompare(b.processorName)
        })
    }
    const dropdown = (e) => {
        if (e === "A") {
            return "Approved"
        } else if (e === "D") {
            return "Denied"
        } else if (e === "C") {
            return "Cancelled"
        } else if (e === "I") {
            return "In Process"
        } else if (e === "N") {
            return "New"
        } else if (e === "F") {
            return "Finished"
        } else { return e }
    }
    const handleSubmit = async () => {

        setIsLoading(true);
        await authAxios.post(`/PDCReturn/requestList`, {
            requestorId: req.requestorId,
            material: req.material,
            plant: req.plant,
            fromDate: req.fromDate,
            toDate: req.toDate,
            status: req.status,
            processorId: req.processorId,
            smUser: info.userId,
            managerId: "",
            flagFromPage: "requestlist"

        }, { headers }).then(
            res => {
                if(res.data.length>0 && res.data[0].flag===true){
                    setAlertVariant('warning');
                    getMessage("Please minimize date range for better results");
                    setAlertVisible(true)
                    makeMessageHidden(10000);
                    setIsLoading(false);
                    getque(res.data);
                    getflagForCount(true);
                    
                    
                }else{
                getflagForCount(false)
                getque(res.data);
                setIsLoading(false);}

            }
        ).catch(err => {
            setAlertVariant('warning');
            getMessage(ERROR_MESSAGE);
            setAlertVisible(true);
            setIsLoading(false);
            makeMessageHidden(5000);
        })

    }

    const columns = useMemo(
        () => [
            {
                Header: "Request Date",
                accessor: "requestDate",
            },
            {
                Header: "Requestor Name",
                accessor: "requestorName",
            },
            {
                Header: "Material",
                accessor: "material",
            },
            {
                Header: "Quantity",
                accessor: "quantity",
            },
            {
                Header: "Urgency",
                accessor: "urgency",
            },
            {
                Header: "Destination",
                accessor: "destination",
            },
            {
                Header: "Status",
                accessor: "status",
            },
            {
                Header: "Processor Name",
                accessor: "processorName",
            },
            {
                Header: "Processor Comment",
                accessor: "processorComment",
            }
        ],
        []
    );


    const requestorList = [];
    const requestorIdList = [];

    const materialList = [];
    const plantList = [];
    const statusList = [];

    const processorList = [];
    const processorIdList = [];


    return (


        <Fragment>
            <title>Request List</title>
            {alertVisible ? <Alert id="snackbar" onClose={hideAlert} accessibilityLabel="Success:" variant={alertVariant} aria-atomic="true">
                <p className="uxf-alert-description">
                    {message}
                </p>
            </Alert> : null}

            <Card style={{ margin: '2%' }}>
                <Card.Body>
                    <Container fluid="xl">
                        <Row>
                            <Col xs={24}>
                                <Form.Group as={Row} className="mb-3" >
                                    <Breadcrumb links={[{
                                        title: "Home",
                                        href: "/"
                                    }, {
                                        title: "Request List",

                                    }]} label="breadcrumbs" />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Container><br />

                    <Form >

                        <Container fluid="xl">
                            <Row>

                                {/* col1 */}

                                <Col xs={12} md={4} style={{ marginRight: '1%' }}>

                                    <Form.Group as={Row} className="mb-3" >
                                        <Form.Label className="uxf-label">
                                            Processor
                                        </Form.Label>

                                        <Form.Control onChange={handleprocessorChange} as="select" className="custom-select" value={processorList.processorName}>
                                            <option value="">ALL</option>
                                            {
                                                queue.forEach(img => {
                                                    if ((processorIdList.indexOf(img.processorId) === -1) && (img.processorId !== null) && (img.processorId.trim().length > 0) && (img.processorName !== null) && (img.processorName.trim().length > 0)) {

                                                        const temp = { processorName: img.processorName, processorId: img.processorId }

                                                        processorList.push(temp)
                                                        processorIdList.push(img.processorId)
                                                    }
                                                }
                                                )
                                            }{sortarray3(processorList)}
                                            {processorList.map((element, index) => {
                                                return (
                                                    <option key={index} selected={element.processorId === req.processorId} value={element.processorId}> {element.processorName}</option>
                                                )

                                            })}

                                        </Form.Control>
                                    </Form.Group>
                                </Col>



                                {/* col2 */}

                                <Col xs={12} md={2} style={{ marginRight: '1%' }}>

                                    <Form.Group as={Row} className="mb-3" >
                                        <Form.Label className="uxf-label">
                                            Plant
                                        </Form.Label>

                                        <Form.Control onChange={handleplantChange} as="select" className="custom-select">
                                            <option value="">ALL</option>
                                            {
                                                queue.forEach(img => {
                                                    if (plantList.indexOf(img.plant) === -1 && (img.plant !== null) && (img.plant.trim().length > 0)) {
                                                        plantList.push(img.plant)
                                                    }
                                                }
                                                )
                                            }{sortarray(plantList)}
                                            {plantList.map((element, index) => {
                                                return (

                                                    <option key={index} selected={element === req.plant} value={element}>{element}</option>
                                                )
                                            })}

                                        </Form.Control>
                                    </Form.Group>
                                </Col>

                                {/* Col3 */}

                                <Col xs={12} md={3} style={{ marginRight: '1%' }}>

                                    <Form.Group as={Row} className="mb-3" >
                                        <Form.Label className="uxf-label">
                                            Material
                                        </Form.Label>

                                        <Form.Control onChange={handlematerialChange} as="select" className="custom-select">
                                            <option value="">ALL</option>
                                            {
                                                queue.forEach(img => {

                                                    if (materialList.indexOf(img.material) === -1 && (img.material !== null) && (img.material.trim().length > 0)) {
                                                        materialList.push(img.material)
                                                    }

                                                }
                                                )
                                            }
                                            {sortarray(materialList)}
                                            {materialList.map((element, index) => {
                                                return (
                                                    (element !== null) ?

                                                        <option key={index} selected={element === req.material} value={element}>{element}</option>

                                                        : null
                                                )
                                            })}

                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                {/* colnew4 */}
                                <Col xs={12} md={2} style={{ marginRight: '1.5%' }}>

                                    <Form.Group as={Row} className="mb-3" >
                                        <Form.Label className="uxf-label">
                                            Status
                                        </Form.Label>

                                        <Form.Control onChange={handlestatusChange} as="select" className="custom-select">
                                            <option value="">ALL</option>
                                            {
                                                queue.forEach(img => {
                                                    if (statusList.indexOf(img.status) === -1 && (img.status !== null) && (img.status.trim().length > 0)) {
                                                        statusList.push(img.status)
                                                    }
                                                }
                                                )
                                            }{sortarray(statusList)}
                                            {statusList.map((element, index) => {
                                                return (

                                                    <option key={index} selected={element === req.status} value={element}>{dropdown(element)}</option>
                                                )
                                            })}

                                        </Form.Control>
                                    </Form.Group>
                                </Col>

                                {/* col5 */}
                                <Col xs={12} md={4} style={{ marginRight: '1%' }}>

                                    <Form.Group as={Row} className="mb-3" >
                                        <Form.Label className="uxf-label">
                                            Requestor
                                        </Form.Label>
                                        <Form.Control onChange={handlerequestorChange} as="select" className="custom-select" value={requestorList.requestorName}>
                                            <option value="">ALL</option>

                                            {queue.forEach(img => {

                                                if (requestorIdList.indexOf(img.requestorId) === -1 && (img.requestorId !== null) && (img.requestorId.trim().length > 0) && (img.requestorName !== null) && (img.requestorName.trim().length > 0)) {
                                                    const temp = { requestorName: img.requestorName, requestorId: img.requestorId }

                                                    requestorList.push(temp)
                                                    requestorIdList.push(img.requestorId);
                                                }
                                            }
                                            )
                                            }
                                            {sortarray2(requestorList)}
                                            {requestorList.map((element, index) => {
                                                return (

                                                    <option key={index} selected={element.requestorId === req.requestorId} value={element.requestorId} >{element.requestorName} </option>

                                                )
                                            })}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>



                                <Col xs={12} md={3} style={{ marginRight: '1%' }}>

                                    <Form.Group as={Row} className="mb-3" >



                                        <DatePicker name="fromdate" selected={req.fromDate} placeholder={startdate1} onInput={handlefromDateChange} labelText="From Date" id="startdate" inputAriaLabel="date format: dd-mmm-yyyy" />

                                    </Form.Group>
                                </Col>
                                <Col xs={12} md={3} style={{ marginRight: '1%' }}>

                                    <Form.Group as={Row} className="mb-3" >


                                        <DatePicker name="todate" selected={req.toDate} onInput={handletoDateChange} placeholder="ToDate" labelText="To Date" id="enddate" inputAriaLabel="date format: yyyy-mm-dd" />


                                    </Form.Group>
                                </Col>

                            </Row>
                        </Container>
                        <br />

                    </Form>

                    {/* {(queue.length !== 0 && flagForCount===false && (isLoading ? (
                        <Loading />
                    ) : (
                        <TableContainerRequestView columns={columns} data={queue} />
                    ))) || ((queue.length === 0 || flagForCount===true)  && (isLoading ? (
                        <Loading />
                    ) :


                        <h6 style={{ fontWeight: "bold" }}>No Data Found</h6>
                        ))} */}

                    {(isLoading?<Loading />:(queue.length === 0?<h6 style={{ fontWeight: "bold" }}>No Data Found</h6>:(flagForCount===true?<h6 style={{ fontWeight: "bold" }}>Resultset is too large to display</h6>:<TableContainerRequestView columns={columns} data={queue} />)))}



                </Card.Body>
            </Card>

        </Fragment>


    );
}